<h3 mat-dialog-title>Arquivos da Tarefa</h3>
<form [formGroup]="form" (ngSubmit)="salvar()">
    <div mat-dialog-content>
        <div fxLayout="column" class="mb-24">
            <div>
                <!-- Botão para selecionar arquivo -->
                <button type="button" color="primary" mat-raised-button (click)="fileInput.click()">
                    Anexar Arquivo
                </button>

                <input 
                    hidden type="file" 
                    #fileInput 
                    multiple
                    (change)="onFileSelected($event)"
                    accept=".xls,.xlsx,.pdf,.csv,.png,.jpeg,.jpg,.svg,.txt,.doc,.docx,.csi"
                />
            </div>

            <div fxLayout="row wrap">
                <mat-list *ngIf="listaArquivos.length > 0">
                    <mat-list-item *ngFor="let arquivoServer of listaArquivos">
                        <span>{{ arquivoServer.path.replace("tarefas/", "") }}</span>
                        <button mat-icon-button type="button" (click)="download(arquivoServer.id, arquivoServer.path)" *ngIf="_actions.buttonDownloadFiles.enabled">
                            <mat-icon>cloud_download</mat-icon>
                        </button>
                        <button mat-icon-button type="button" color="warn" (click)="delete(arquivoServer.id)" *ngIf="_actions.buttonDeleteFiles.enabled">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </mat-list-item>
                </mat-list>
                <mat-list *ngIf="arquivosSelecionados.length > 0">
                    <mat-list-item *ngFor="let arquivo of arquivosSelecionados; let i = index">
                        <span>{{ arquivo.name }}</span>
                        <button mat-icon-button type="button" color="warn" (click)="removerArquivo(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </mat-list-item>
                </mat-list>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button mat-button type="button" tabindex="2" (click)="onNoClick()">Cancelar</button>
        <button mat-button type="submit" tabindex="-1" [disabled]="this.arquivosSelecionados.length==0">
            Salvar
        </button>
    </div>
</form>